import invert from "lodash/invert";

const ExpiryType = {
  Weekly: "WEEKLY",
  Monthly: "MONTHLY",
  NA: "NA",
} as const;

const intervalToExpiryType = {
  weeks: ExpiryType.Weekly,
  months: ExpiryType.Monthly,
  unlimited: ExpiryType.NA,
} as const;

const expiryTypeToInterval = invert(intervalToExpiryType);

Object.setPrototypeOf(ExpiryType, {
  fromInterval: (interval: keyof typeof intervalToExpiryType) =>
    intervalToExpiryType[interval],
  toInterval: (expiryType: (typeof ExpiryType)[keyof typeof ExpiryType]) =>
    expiryTypeToInterval[expiryType],
  format(
    expiryType: (typeof ExpiryType)[keyof typeof ExpiryType],
    isPlural = false,
  ) {
    let text = expiryTypeToInterval[expiryType];
    if (!isPlural && text[text.length - 1] === "s") {
      text = text.substring(0, text.length - 1);
    }

    return text;
  },
});

export default ExpiryType;
